import { makeNoteMockData } from '../../modules/noteMockDataFactory'
import type { ISupplierNote } from '~/types/note/models'

export const {
  getNoteListData: getSupplierNoteListData,
  getNoteDataById: getSupplierNoteDataById,
  getNoteListDataByParentId: getSupplierNoteListDataBySupplierId,
} = makeNoteMockData<ISupplierNote>({
  entityName: 'supplier',
  storageKeyPrefix: 'supplier',
})
